//电量报表
const repPowerZh = {
  repPowerLang: {
    电量报表: '电量报表',
    站点汇总展示所有站点报表数据支持按日展示31天按月展示一年内数据: '站点汇总展示所有站点报表数据，支持按日展示31天，按月展示一年内数据。',
    站点汇总: '站点汇总',
    单站报表: '单站报表',
    时间范围: '时间范围',
    开始日期: '开始日期',
    结束日期: '结束日期',
    开始月份: '开始月份',
    结束月份: '结束月份',
    开始年份: '开始年份',
    结束年份: '结束年份',
    请选择: '请选择',
    查询: '查询',
    重置: '重置',
    报表导出: '报表导出',
    站点名称: '站点名称',
    充电量: '充电量',
    尖: '尖',
    峰: '峰',
    平: '平',
    谷: '谷',
    总: '总',
    放电量: '放电量',
    综合效率: '综合效率',
    暂无数据: '暂无数据',
    按日: '按日',
    按月: '按月',
    按年: '按年',
    请选择时间范围: '请选择时间范围！',
    报表类型: '报表类型',
    时段报表: '时段报表',
    日报表: '日报表',
    月报表: '月报表',
    年报表: '年报表',
    选择站点: '选择站点',
    日期: '日期',
    请选择站点: '请选择站点！',
    总计: '总计',
    选择日期: '选择日期',
    时段数据: '时段数据',
    折线图: '折线图',
    柱状图: '柱状图',
    表格: '表格',
    原始数据: '原始数据',
    当日数据: '当日数据',
    累计数据: '累计数据',
    当日数据导出: '当日数据导出',
    累计数据导出: '累计数据导出',
    数据导出: '数据导出',
    起止时间: '起止时间',
    取消: '取消',
    确定: '确定'
  }
}
export default repPowerZh
